import { render, staticRenderFns } from "./UserResendInviteDialog.vue?vue&type=template&id=27ad7c7b&scoped=true"
import script from "./UserResendInviteDialog.vue?vue&type=script&lang=ts"
export * from "./UserResendInviteDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserResendInviteDialog.vue?vue&type=style&index=0&id=27ad7c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ad7c7b",
  null
  
)

export default component.exports